import React from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { Bttn } from '../../../../views/WorkOrders/WorkOrders.styles';

const NavigationBtns = ({ setDisableNext, onCancel }) => {
  const navigate = useNavigate();
  const { type } = useSelector((state) => state.upsertWorkOrder);
  const handleCancel = (...params) => {
    if (onCancel) {
      onCancel(...params);
    } else {
      navigate(-1);
    }
  };
  return (
    <>
      <Bttn className='white' onClick={handleCancel}>
        Cancel
      </Bttn>
      <Bttn
        disabled={!type.Type}
        onClick={() => navigate('/home/work_orders/create_WO/filter')}
      >
        Next
      </Bttn>
    </>
  );
};

export default NavigationBtns;
